export const listIntegrations = async (sendAndWaitWs) => {
  const response = await sendAndWaitWs("/integration/list", JSON.stringify({}));
  if (response.error) {
    return null;
  }
  return JSON.parse(response.payload);
};

export const listEntities = async (sendAndWaitWs, integration) => {
  const response = await sendAndWaitWs(
    "/integration/entity/list",
    JSON.stringify({ integration })
  );
  if (response.error) {
    return null;
  }
  return JSON.parse(response.payload);
};

export const getIntegration = async (sendAndWaitWs, integration) => {
  const response = await sendAndWaitWs(
    "/integration/get",
    JSON.stringify({ integration })
  );
  if (response.error) {
    return null;
  }
  return JSON.parse(response.payload);
};

export const listGroups = async (sendAndWaitWs, integration) => {
  const response = await sendAndWaitWs(
    "/integration/group/list",
    JSON.stringify({ integration })
  );
  if (response.error) {
    return null;
  }
  return JSON.parse(response.payload);
};

export const listProviders = async (sendAndWaitWs, integration) => {
  const response = await sendAndWaitWs(
    "/integration/provider/list",
    JSON.stringify({ integration })
  );
  if (response.error) {
    return null;
  }
  return JSON.parse(response.payload);
};

export const installIntegration = async (sendAndWaitWs, integration) => {
  const response = await sendAndWaitWs(
    "/integration/install",
    JSON.stringify({ integration })
  );
  if (response.error) {
    return null;
  }
  const result = JSON.parse(response.payload);
  return result && result.success;
};

export const uninstallIntegration = async (sendAndWaitWs, integration) => {
  const response = await sendAndWaitWs(
    "/integration/uninstall",
    JSON.stringify({ integration })
  );
  if (response.error) {
    return null;
  }
  const result = JSON.parse(response.payload);
  return result && result.success;
};

export const saveGroup = async (sendAndWaitWs, group) => {
  const response = await sendAndWaitWs(
    "/integration/group/save",
    JSON.stringify(group)
  );
  if (response.error) {
    return null;
  }
  return JSON.parse(response.payload);
};

export const deleteGroup = async (sendAndWaitWs, req) => {
  const response = await sendAndWaitWs(
    "/integration/group/delete",
    JSON.stringify(req)
  );
  if (response.error) {
    return null;
  }
  return JSON.parse(response.payload);
};

export const disconnectIntegration = async (
  sendAndWaitWs,
  integration,
  connectId
) => {
  const response = await sendAndWaitWs(
    "/integration/disconnect",
    JSON.stringify({ integration, connectId })
  );
  if (response.error) {
    return null;
  }
  return JSON.parse(response.payload);
};

export const syncEntities = async (sendAndWaitWs, integration) => {
  const response = await sendAndWaitWs(
    "/integration/entity/sync",
    JSON.stringify({ integration })
  );
  if (response.error) {
    return null;
  }
  const result = JSON.parse(response.payload);
  return result && result.success;
};

export const startConnectIntegration = async (sendAndWaitWs, integration) => {
  const response = await sendAndWaitWs(
    "/integration/connection/start",
    JSON.stringify({ integration })
  );
  if (response.error) {
    return response.error;
  }
  return JSON.parse(response.payload);
};

export const completeConnectIntegration = async (
  sendAndWaitWs,
  integration,
  customConnect
) => {
  const response = await sendAndWaitWs(
    "/integration/connection/complete",
    JSON.stringify({ integration, customConnect })
  );
  if (response.error) {
    return response.error;
  }
  return JSON.parse(response.payload);
};

export const getIntegrationModel = async (sendAndWaitWs, integrationId) => {
  const response = await sendAndWaitWs(
    "/integration/model/get",
    JSON.stringify({ integrationId })
  );
  if (response.error) {
    return response.error;
  }
  return JSON.parse(response.payload);
};
